import { SideMenuItem } from "@albelli/arc-3-react/lib/SideMenu";
import { useHistory, useLocation } from "components/_hooks/useRouter";
import React, { useCallback } from "react";

export const SideMenuNavItem = ({ href, children, ...props }) => {
  const history = useHistory();
  const location = useLocation();
  const navigateTo = (e, href) => {
    e.preventDefault();
    history.push(href);
  };

  const isCurrentPath = useCallback(
    href => {
      if (href === "/") return location.pathname === href;

      return location.pathname.indexOf(href) >= 0;
    },
    [href, location]
  );

  const { staticContext, match, ...filteredProps } = props;

  return (
    <SideMenuItem href={href} onClick={e => navigateTo(e, href)} isActive={isCurrentPath(href)} {...filteredProps}>
      {children}
    </SideMenuItem>
  );
};
